import type { MapPlace } from '@fontbold/ui';
import { queryOptions } from '@tanstack/react-query';
import { graphql } from '#/lib/gql';
import { fetchGraphQL } from '#/lib/graphql';

const MOBILE_MAP_QUERY = graphql(`
  query MobileMapPlaces($spaceId: String!) {
    place(spaceId: $spaceId) {
      findForMap { id name path coordinates { latitude longitude } }
    }
  }
`);

async function fetchMapPlaces(spaceId: string): Promise<MapPlace[]> {
  const data = await fetchGraphQL(MOBILE_MAP_QUERY, { spaceId });
  return (data?.place?.findForMap ?? []).flatMap((place) =>
    place
      ? [
          {
            id: place.id,
            name: place.name,
            latitude: place.coordinates.latitude,
            longitude: place.coordinates.longitude,
            href: place.path,
          },
        ]
      : [],
  );
}

export const placeMapQueries = {
  all: (spaceId: string) =>
    queryOptions({
      queryKey: ['places', 'map', spaceId] as const,
      queryFn: () => fetchMapPlaces(spaceId),
      staleTime: 5 * 60 * 1000,
    }),
};
